// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mw-0";